import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    LabelList
} from "recharts";
import '../styles/AddOns.css'

const QuotaBarChart = ({ data }) => {
    console.log("Data of barchart:", data);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isSmallScreen = screenWidth <= 480;

    const leftMargin = isSmallScreen ? 20 : 0;
    const yAxisWidth = isSmallScreen ? 50 : 100;

    const chartHeight = screenWidth <= 480 ? data.length * 60 : 400;
    const fontSize = screenWidth <= 480 ? 10 : 12;
    const barGap = screenWidth <= 480 ? "25%" : "15%";

    // Custom tooltip to show used, unused, total
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const used = payload[0].payload.used;
            const unused = payload[0].payload.unused;
            const total = used + unused;

            return (
                <div style={{ background: "#fff", border: "1px solid #ccc", padding: 8, borderRadius: 6 }}>
                    <strong>{label}</strong>
                    <div style={{ marginTop: 4 }}>
                        <div style={{ color: "#28a745" }}>Consumed: {used}</div>
                        <div style={{ color: "#6c757d" }}>Available: {unused}</div>
                        <div style={{ fontWeight: 600 }}>Limit: {total}</div>
                    </div>
                </div>
            );
        }
        return null;
    };

    return (
        <div
            style={{
                width: "100%",
                marginTop: 20,
                background: "linear-gradient(180deg, #f5f8ff 0%, #e6ebff 100%)",
                padding: 20,
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
        >
            <ResponsiveContainer width="100%" height={chartHeight}>
                <BarChart
                    data={data}
                    layout="vertical"
                    margin={{ top: 20, right: 20, left: leftMargin, bottom: 20 }}
                    barCategoryGap={barGap}
                    tabIndex={-1}
                >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />

                    <XAxis type="number" />

                    <YAxis
                        dataKey="name"
                        type="category"
                        width={yAxisWidth}
                        tick={{ fontSize }}
                        tickFormatter={(text) =>
                            isSmallScreen && text.length > 10 ? text.slice(0, 10) + "…" : text
                        }
                    />

                    <Tooltip content={<CustomTooltip />} />

                    {/* USED BAR */}
                    <Bar dataKey="used" stackId="quota" name="Used" activeBar={false}>
                        {data.map((item, index) => {
                            const total = item.used + item.unused;
                            const percent = (item.used / total) * 100;
                            let color = "#28a745"; // green
                            if (percent >= 80) color = "#dc3545"; // red
                            else if (percent >= 50) color = "#ffc107"; // orange
                            return <Cell key={index} fill={color} radius={[10, 0, 0, 10]} />;
                        })}
                        <LabelList
                            dataKey="used"
                            position="insideRight"
                            fill="#fff"
                            fontSize={fontSize}
                            fontWeight={600}
                        />
                    </Bar>

                    {/* UNUSED BAR */}
                    {/* UNUSED BAR */}
                    <Bar dataKey="unused" stackId="quota" fill="#cbd0d6" name="Unused" activeBar={false}>
                        {data.map((item, index) => (
                            <Cell key={index} radius={[0, 10, 10, 0]} />
                        ))}
                        <LabelList
                            dataKey="unused"
                            position="right"
                            content={(props) => {
                                const { x, y, width, height, index } = props;
                                const item = data[index];
                                if (!item) return null;
                                const total = item.used + item.unused;
                                return (
                                    <text
                                        x={x + width + 5} // 5px to the right of the bar
                                        y={y + height / 2 + 4}
                                        textAnchor="start"
                                        fill="#000"
                                        fontSize={fontSize}
                                        fontWeight={600}
                                    >
                                        {total}
                                    </text>
                                );
                            }}
                        />
                    </Bar>

                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default QuotaBarChart;
